exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "html[dir] ._3T4GAqsOwvgOWnDQZOa_t2{background:var(--outlookDesktopPaneBackground)}", ""]);
// Exports
exports.locals = {
	"contentRoot": "_3T4GAqsOwvgOWnDQZOa_t2"
};